import React from "react";
import borderImg from "../../../public/menu-divider.png";
import "./styles.scss";

export default ({ thick }) => (
  <div className="menu-divider d-flex flex-column w-100">
    <img
      src={borderImg}
      className={`colored-line ${thick ? "w-100" : ""}`}
      alt="rinbow-line"
    />
    <div className={`black-line bg-dark ${thick ? "thick" : ""}`} />
  </div>
);
